import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import tringlogo from '../images/tring.png';

const drawerWidth = 240;
const navList = [
    {
        name: "Audio Files",
        link: "audiofiles"
    },
    {
        name: "Users",
        link: "users"
    },
    {
        name: "Winning Numbers Records",
        link: "winningnumbersrecords"
    },
    {
        name: "Clients",
        link: "clients"
    },
    {
        name: "Advertisements",
        link: "advertisements"
    },
    {
        name: "Reports",
        link: "reports"

    },
    {
        name: "Settings",
        link: "settings"
    },
    {
        name: "Bugs Reported by Users",
        link: "bugsreportedbyusers"
    },
]

export default function Dashboard() {
    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}
            >
                <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h6" noWrap component="div">
                        Dashboard
                    </Typography>
                    <Typography variant="h6" noWrap component="div">
                        <div>POT PRIZE MONEY</div>
                        <div>1,00,780 Rs</div>
                    </Typography>
                    <Link to={"addwinningnumber "}> <Button variant="contained" color="success"> Enter Today's Winning Number </Button></Link>
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="permanent"
                anchor="left"
            >
                <img src={tringlogo} alt="tring-logo" />
                <Toolbar />

                <List>

                    {navList.map((text) => (
                        <ListItem key={text.name} disablePadding>
                            <ListItemButton>
                                <Link to={text.link}> <Button variant="contained" color="success"> {text.name} </Button></Link>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
            <Box
                component="main"
                sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
            >
                <Toolbar />
                <h1 style={{ display: 'flex', justifyContent: 'flex-start' }} >User Stats</h1>
                <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="h7" noWrap component="div">
                            Total Users
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            45,00,000
                        </Typography>
                    </Box>
                    <div>
                        <Typography variant="h7" noWrap component="div">
                            New Users
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            5,300
                        </Typography>
                    </div>
                    <div>
                        <Typography variant="h7" noWrap component="div">
                            Recurring Users
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            5,30,000
                        </Typography>
                    </div>
                    <div>
                        <Typography variant="h7" noWrap component="div">
                            Retention Rate
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            30%
                        </Typography>
                    </div>
                </Box>


                <h1 style={{ display: 'flex', justifyContent: 'flex-start' }} >Prediction Stats</h1>
                <Box style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', p: 3 }}>
                    <Box>
                        <Typography variant="h7" noWrap component="div">
                            Total Predictions
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            45,00,000
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h7" noWrap component="div">
                            Today's Predictions
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            5,30,000
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h7" noWrap component="div">
                            This Week's Predictions
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            40,00,000
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h7" noWrap component="div">
                            This Month's Predictions
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            40,00,000
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h7" noWrap component="div">
                            Today's Unique Predictions
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            35,000
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h7" noWrap component="div">
                            Predictions via APP
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            3,30,000
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h7" noWrap component="div">
                            Predictions via Call/IVR
                        </Typography>
                        <Typography variant="h7" noWrap component="div">
                            2,00,000
                        </Typography>
                    </Box>
                </Box>
                <h1 style={{ display: 'flex', justifyContent: 'flex-start' }} >Regional Stats</h1>


            </Box>
        </Box >
    );
}
